import { identifyUser, initializeEventWrapper } from 'src/utils/segmentService';
import { getSessionUser } from './Auth.thunks';

export const getPostAuthRedirectPath = (
  basePath: string,
  search: string
): string => {
  const searchParams = new URLSearchParams(search);
  const queryString = searchParams.toString();

  return queryString ? `${basePath}?${queryString}` : basePath;
};

interface SyncAuthenticatedUserSessionParams {
  updateUserAsync: (user: {
    userID: string;
    email?: string;
  }) => Promise<unknown>;
}

export const syncAuthenticatedUserSession = async ({
  updateUserAsync,
}: SyncAuthenticatedUserSessionParams): Promise<boolean> => {
  const user = getSessionUser();

  if (!user) {
    return false;
  }

  await updateUserAsync({
    userID: (user?.staffid ?? 'anonymous').toString(),
    email: user?.email,
  });
  identifyUser(user.staffid, {
    email: user.email,
    name: user.fullname,
    username: user.username,
    company_id: user.company_id,
  });
  initializeEventWrapper(user.company_id);

  return true;
};
